import type { GetInvoiceAlertsResult } from '@features/invoices/api/get-invoice-alerts/getInvoiceAlerts.types';
import type { UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@contexts/auth-provider/hooks/use-auth/useAuth';
import { useOrganizations } from '@contexts/organizations-provider';
import { getInvoiceAlerts } from '@features/invoices/api/get-invoice-alerts/getInvoiceAlerts';
import { useQuery } from '@tanstack/react-query';

export function useInvoiceAlerts(): UseQueryResult<
  GetInvoiceAlertsResult,
  Error
> {
  const { isAuthenticated } = useAuth();
  const { selectedOrganization } = useOrganizations();
  const organizationId = selectedOrganization?.id ?? '';

  return useQuery<GetInvoiceAlertsResult, Error>({
    queryKey: ['invoices', 'alerts', organizationId],
    queryFn: () => getInvoiceAlerts({ organizationId }),
    enabled: isAuthenticated && !!selectedOrganization,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
